import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useMemo, useState } from "react";
import PopoverMenu from "./PopoverMenu";
import { t } from "i18next";
import { hexToRgb } from "utils/colors.utils";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import Tooltip from "./Tooltip";
import { WalletIcon } from "../../icons/index.js";
import { scaleNumber, toFixedTrunc } from "utils/MathHelpers";
var HeaderWallet = function (_a) {
    var balance = _a.balance, status = _a.status, isLoading = _a.isLoading, theme = _a.theme, billingType = _a.billingType, isQuotaEnabled = _a.isQuotaEnabled;
    var navigate = useNavigate();
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useContext(AuthContext), userScope = _c.userScope, currencySymbol = _c.currencySymbol, loggedInRole = _c.loggedInRole, globalConfigMap = _c.globalConfigMap;
    var enableWallet = globalConfigMap.isEnabled("enableWallet", true);
    var enableTransferCredits = globalConfigMap.isEnabled("enableTransferCredits", true);
    var smsDashboard = globalConfigMap.isEnabled("isSMSDashboardEnabled", false);
    var options = useMemo(function () {
        var _a;
        var walletTransfer = (_a = userScope === null || userScope === void 0 ? void 0 : userScope.wallets) === null || _a === void 0 ? void 0 : _a.transfer;
        var renderWalletPage = function () {
            navigate("/app/header/wallets");
        };
        var renderTransferCreditsPage = function () {
            navigate("/app/header/transfercredits");
        };
        var CreditLimitPage = function () {
            navigate("/app/header/CreditLimitList");
        };
        var options = [];
        if (enableWallet) {
            options.push({
                value: "_My_wallet",
                label: t("_My_wallet"),
                onClick: renderWalletPage,
            });
        }
        if (enableTransferCredits && loggedInRole != "EU") {
            options.push({
                disabled: !walletTransfer,
                value: "_Transfer_Credits",
                label: t("_Transfer_Credits"),
                onClick: function () {
                    if (smsDashboard && billingType === "postpaid") {
                        CreditLimitPage();
                    }
                    else if (walletTransfer) {
                        renderTransferCreditsPage();
                    }
                },
            });
        }
        return options;
    }, [
        userScope,
        smsDashboard,
        enableTransferCredits,
        enableWallet,
        billingType,
        loggedInRole,
    ]);
    return (balance && (_jsx(PopoverMenu, { options: options, open: open, setOpen: setOpen, contentMinWidth: "150px", className: "px-6 py-3", children: _jsx("div", { children: _jsx(Tooltip, { disabled: open, content: isQuotaEnabled
                    ? balance
                    : currencySymbol + " " + toFixedTrunc(Math.abs(balance)), children: _jsxs("div", { className: "relative  py-1 rounded-[8px] bg-opacity-[0.06] flex items-center cursor-pointer select-none", style: {
                        backgroundColor: "rgba(".concat(hexToRgb(theme.secondaryColor), ", 0.1)"),
                    }, children: [_jsx("div", { className: "ltr:ml-3 rtl:mr-3 py-1", children: _jsx(WalletIcon, { className: "w-6 h-5", style: { color: theme.secondaryColor } }) }), _jsx("div", { className: "flex relative   flex-col ml-2 text mx-4", children: status === "success" &&
                                !isLoading &&
                                (isQuotaEnabled ? (_jsx("h1", { style: { color: theme.secondaryColor }, className: " font-bold opacity-100 text-sm", children: scaleNumber(balance) })) : (_jsxs("h1", { style: { color: theme.secondaryColor }, className: " font-bold opacity-100 text-sm", children: [currencySymbol, " ", scaleNumber(balance)] }))) })] }) }) }) })));
};
export default HeaderWallet;
